import { createNativeAction } from './createNativeAction';
export const closeAppFromNative = createNativeAction('CLOSE_WEB_VIEW');